import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { AuthService } from '../../../services/auth.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter } from 'rxjs/operators';

@Component({
	selector: 'app-instagram',
	templateUrl: './instagram.component.html',
	styleUrls: ['./instagram.component.scss']
})
export class InstagramComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('instagramForm', { static: true }) instagramForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	instagramFormSubscription: Subscription;
	hiddenGridWrap = true;
	defaultChanged = false;
	tilesList = [false, false, false, false, false, false, false, false, false, false, false, false];
	spacing;
	maxImages = Boolean(false);
	isAdmin;
	totalImages;

	constructor(private comService: ComponentService, private auth: AuthService) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();
		this.instagramFormSubscription = this.instagramForm.valueChanges
			.pipe(
				tap(() =>
					this.comService.updateDisabledSave(
						(this.instagramForm.dirty && this.instagramForm.invalid) || this.nameField.editComponentName
					)
				),
				filter((form) => this.instagramForm.dirty && this.instagramForm.valid)
			)
			.subscribe();

		this.spacing = this.componentData.config.spacing ? 'show' : 'hide';
		this.repeatChange();
	}

	ngOnDestroy() {
		this.instagramFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	gridChange() {
		this.repeatChange();
	}

	repeatChange() {
		this.totalImages = this.componentData.config.repeat * this.componentData.config.cols * this.componentData.config.rows;
		if (this.totalImages > 12) {
			this.maxImages = true;
			setTimeout(() => {
				this.comService.updateDisabledSave(true);
			}, 20);
		} else {
			this.maxImages = false;
			this.comService.updateDisabledSave(false);
		}
	}

	tileClick(ind) {
		this.componentData.config.cols = (ind + 1) % 4 ? (ind + 1) % 4 : 4;
		this.componentData.config.rows = Math.ceil((ind + 1) / 4);
		this.hiddenGridWrap = true;
	}

	tileHover(ind) {
		const row = (ind + 1) % 4 ? (ind + 1) % 4 : 4;
		for (let i = 0; i < 12; i++) {
			const correntRow = (i + 1) % 4 ? (i + 1) % 4 : 4;
			if (i <= ind && correntRow <= row) {
				this.tilesList[i] = true;
			} else {
				this.tilesList[i] = false;
			}
		}
	}
}
